import React, { memo } from 'react';
import block from 'bem-cn';
import isEqual from 'lodash.isequal';

import { PragmaticDGABoomOrBust } from 'components/slots/PragmaticDGA/hooks';

import {
  blank,
  boomOrBust,
  container1,
  container2,
  container5,
  diceBattle,
  lastBlank,
  lastBoomOrBust,
  lastContainer1,
  lastContainer2,
  lastContainer5,
  lastDiceBattle,
  lastLuckyDrop,
  luckyDrop,
  powerUp,
} from './img';

import './BoomOrBust.scss';

const b = block('pragmatic-dga-boom-or-bust');

type BoomOrBustProps = {
  results: PragmaticDGABoomOrBust['gameResult']
};

type Result = PragmaticDGABoomOrBust['gameResult'][number]['result'];

const mapResultToBackgroundImage: Record<Result, string> = {
  '1x': container1,
  '2x': container2,
  '5x': container5,
  BLANK: blank,
  BG1: boomOrBust,
  BG2: luckyDrop,
  BG3: diceBattle,
};

const mapLastResultToBackgroundImage: Record<Result, string> = {
  '1x': lastContainer1,
  '2x': lastContainer2,
  '5x': lastContainer5,
  BLANK: lastBlank,
  BG1: lastBoomOrBust,
  BG2: lastLuckyDrop,
  BG3: lastDiceBattle,
};

const getBackgroundImage = (result: Result, index: number) => {
  if (index === 0) return mapLastResultToBackgroundImage[result];
  return mapResultToBackgroundImage[result];
};

const textValues: Result[] = ['1x', '2x', '5x'];

export const BoomOrBust = memo(({ results }: BoomOrBustProps) => (
  <div className={b()}>
    {results.map(({ result, powerUp: isPowerUp, powerUpList, powerUpTotal }, index) => {
      const backgroundImage = getBackgroundImage(result, index);
      const isTextValue = textValues.includes(result);

      const valueContent = (
        <div
          key={index}
          className={b('result')}
          style={{ backgroundImage: `url(${backgroundImage})`}}
        >
          {isTextValue && (
            <span className={b('result-value', { powerUp: isPowerUp })}>
              {powerUpTotal}x
            </span>
          )}
        </div>
      );

      if (isPowerUp) {
        return (
          <div className={b('result-container')} key={index}>
            {valueContent}
            {powerUpList.map((_, mulIndex) => (
              <div
                key={mulIndex}
                className={b('result')}
                style={{ backgroundImage: `url(${powerUp})`}}
              />
            ))}
          </div>
        )
      }

      return valueContent;
    })}
  </div>
), isEqual);
